export default {
    en: {
        message: {
            // Book.vue (and others)
			clickForDimensions:'Click here for dimensions',
			rentalDetails:'Rental Details',
			filters: 'Filter and Sort',
            pickUpLocation: 'Pick-Up Location',
            pickUpDate: 'Date',
            pickUpTime: 'Time',
            returnLocation: 'Return Location',
            returnDate: 'Date',
            returnTime: 'Time',
            noOffersFound: 'No offers found',
            showCars: 'Show Cars',
            pickUpDateLaterThanReturnDate: 'Return date should be later than pickup date',
            noSelectedReturnLocation: 'No selected return location!',
            noSelectedPickupLocation: 'No selected pickup location!',
            // Quotes.vue
            weFoundXOffers: 'We found {amount} offers',
            carType: "Car Type",
            seats: "Seats",
            transmission: "Transmission",
            fuelType: "Kraftstoffart",
            clearFilter: "Clear Filter",
            bookingSubmitted: "Booking submitted.",
            pleaseTryAgainWithRightInformatiom: "Please .. try again with right information!",
            carLarge: "Large",
            carCompact: "Compact",
            carSuv: "SUV",
            carSmall: "Small",
            carStationWagon: "Station Wagon",
            car5Plus: "+5 Seats",
            carVan: "Van",
            petrol: "Petrol",
            diesel: "Diesel",
            electric: "Electric",

            // Options.vue
            bags: 'Bags | Bag | Bags',
            satelliteNavigation: "Satellite Navigation",
            suitcases: "Suitcases | Suitecase | Suitcases",
            doors: "Doors | Door | Doors",
            airConditioning: "Air Conditioning",
            extras: "Extras",
            includedExtras: "Included Extras",
            perDay: "per Day",
            includedItem: "included",
            cdw: "Collision Damage Waiver (CDW)",
            tp: "Theft protection (TP)",
            pai: "Personal Accident Insurance (PAI)",
            amount: "Amount",
            maximumAmountIs: "Maximum amount is",
            kilometer: "Kilometer",
            preliminaryBookingRequestSentence: "Preliminary booking request, subject to car availability. You will receive a confirmation from us if this car is available.",
            booking: "Book",
            rebookingAndCancellationSentence: "Changes and cancellations must be made no later than 24 hours before pick-up time.",
            personalInfo: "Personal Information",
            driverCompany: "Company (optional)",
            driverFirstName: "Driver First Name",
            driverLastName: "Driver Last Name",
            eMail: "E-Mail",
            phoneNumber: "Phone Number",
            streetAddress: "Street Address",
            zipCode: "Zip Code",
            city: "City",
            country: "Country",
            automatic: "Automatic Transmission",
            manual: "Manual Transmission",
            drivingLengthKm: "driving length",
            unlimitedKm: "Unlimited",
            needMoreKm: "Need more km? Add here.",
            rentalTermConfirmFirst: "I have read and accepted the ",
            rentalTermConfirmSecond: "rental agreement.",
            commentOrInformation: "Comments / Other information",
            price: "Price",
            insurance: "Insurance",
            continue: "Continue",
            carInformation: "Overview",

            // Generic
            error: 'Error',
            confirmation: 'Confirmation',
            select: "Select",
            pleaseWaitAMoment: "Please wait a moment ...",
            back: "Back"

        }
    },
    de: {
        message: {
			clickForDimensions:'Klicken Sie hier für die Abmessungen',
			rentalDetails:'Details zur Miete',
			filters:'Filtern und Sortieren',
            pickUpLocation: 'Abholstation',
            pickUpDate: 'Abholdatum',
            pickUpTime: 'Abholzeit',
            returnLocation: 'Rückgabestation',
            returnDate: 'Rückgabedatum',
            returnTime: 'Rückgabezeit',
            noOffersFound: 'Keine Angebote Gefunden',
            showCars: 'Zeige Autos',
            pickUpDateLaterThanReturnDate: 'Abholzeit muss vor Rückgabezeit sein',
            noSelectedReturnLocation: 'Keine Rückgabestation',
            noSelectedPickupLocation: 'Keine Abholstation',
            // Quotes.vue
            weFoundXOffers: 'Wir haben {amount} Angebote gefunden',
            carType: "Art des Autos",
            seats: "Sitze",
            transmission: "Getriebe",
            fuelType: "Kraftstoffart",
            clearFilter: "Filter löschen",
            bookingSubmitted: "Buchung abgeschickt.",
            pleaseTryAgainWithRightInformatiom: "Bitte mit anderen Angaben probieren!",
            carLarge: "Groß",
            carCompact: "Kompakt",
            carSuv: "SUV",
            carSmall: "Klein",
            carStationWagon: "Kombi",
            car5Plus: "+5 Sitzer",
            carVan: "Van",
            petrol: "Benzin",
            diesel: "Diesel",
            electric: "Elektrisch",

            // Options.vue
            bags: "Taschen | Tasche | Taschen",
            satelliteNavigation: "Navigationssystem",
            suitcases: "Koffer | Koffer | Koffer",
            doors: "Türen | Tür | Türen",
            airConditioning: "Klimaanlage",
            extras: "Extras",
            includedExtras: "Inkludierte Extras",
            perDay: "pro Tag",
            includedItem: "inklusive",
            cdw: "Verzicht bei Unfallschäden (CDW)",
            tp: "Diebstahlschutz (TP)",
            pai: "Insassenunfallversicherung (PAI)",
            amount: "Anzahl",
            maximumAmountIs: "Maximale Anzahl ist",
            kilometer: "Kilometer",
            preliminaryBookingRequestSentence: "Buchungsanfrage. Sie erhalten von uns eine Bestätigung, ob dieses Auto verfügbar ist.",
            booking: "Buchung",
            rebookingAndCancellationSentence: "Änderungen und Stornierungen müssen spätestens 24 Stunden vor der Abholzeit erfolgen.",
            personalInfo: "Persönliche Daten",
            driverCompany: "Firma (optional)",
            driverFirstName: "Vorname des Fahrers",
            driverLastName: "Nachname des Fahrers",
            eMail: "E-Mail",
            phoneNumber: "Telefonnummer",
            streetAddress: "Strasse",
            zipCode: "PLZ",
            city: "Stadt",
            country: "Land",
            automatic: "Automatik-Getriebe",
            manual: "Gangschaltung",
            drivingLengthKm: "Anzahl Kilometer",
            unlimitedKm: "Unbegrenzt",
            needMoreKm: "Mehr Kilometer benötigt? Hier hinzufügen",
            rentalTermConfirmFirst: "Ich habe folgendes gelesen und diesem zugestimmt: ",
            rentalTermConfirmSecond: "Mietvertrag.",
            commentOrInformation: "Kommentarer / øvrig informasjon",
            price: "Preis",
            insurance: "Versichungen",
            continue: "Fortfahren",
            carInformation: "Übersicht",

            // Generic
            error: 'Fehler',
            confirmation: 'Bestätigung',
            select: "Auswählen",
            pleaseWaitAMoment: "Bitte warten ...",
            back: "Zurück",


        }
    },
    no: {
        message: {
            // Book.vue (and others)
			clickForDimensions:'Trykk her for dimensjoner',
			rentalDetails:"Dine Leiedetaljer",
			filters:'Filtrer og Sortere',
            pickUpLocation: 'Bilen hentes',
            pickUpDate: 'Dato',
            pickUpTime: 'Tidspunkt',
            returnLocation: 'Bilen leveres',
            returnDate: 'Dato',
            returnTime: 'Tidspunkt',
            noOffersFound: 'Ingen tilbud funnet',
            showCars: 'Vis biler',
            pickUpDateLaterThanReturnDate: 'Tidspunkt for retur må være etter tidspunkt for utlevering',
            noSelectedReturnLocation: 'Ingen returlokasjon valgt',
            noSelectedPickupLocation: 'Ingen utleveringslokasjon valgt',
            // Quotes.vue
            weFoundXOffers: 'Vi fant {amount} tilbud',
            carType: "Biltype",
            seats: "Seter",
            transmission: "Girtype",
            fuelType: "Drivstoff",
            clearFilter: "Nullstill filter",
            bookingSubmitted: "Bestilling registrert",
            pleaseTryAgainWithRightInformatiom: "Vennligst prøv igjen med riktig informasjon",
            carLarge: "Stor",
            carCompact: "Kompakt",
            carSuv: "SUV",
            carSmall: "Liten",
            carStationWagon: "Stasjonsvogn",
            car5Plus: "+5 Seter",
            carVan: "Varebil",
            petrol: "Bensin",
            diesel: "Diesel",
            electric: "Elektrisk",

            // Options.vue
            bags: 'Bags | Bag | Bags',
            satelliteNavigation: "Navigasjon",
            suitcases: "Kofferter | Kofferter | Kofferter",
            doors: "Dører | Dører | Dører",
            airConditioning: "Air Conditioning",
            extras: "Ekstra produkter",
            includedExtras: "Inkluderte ekstra",
            includedItem: "inkludert",
            perDay: "per døgn",
            cdw: "Skadeforsikring (CDW)",
            tp: "Tyveriforsikring (TP)",
            pai: "Personlig ulykkesforsikring (PAI)",
            amount: "Beløp",
            maximumAmountIs: "Maksimum beløp er",
            kilometer: "Kilometer",
            preliminaryBookingRequestSentence: "Foreløpig forespørsel, valgte bilgruppe har begrenset tilgjengelighet. Du vil motta ett svar på din forespørsel snarlig",
            booking: "Bestill nå",
            rebookingAndCancellationSentence: "Endring og kansellering må skje senest 24 timer før uthentingstidspunkt",
            personalInfo: "Din informasjon",
            driverCompany: "Bedrift (valgfritt)",
            driverFirstName: "Fornavn",
            driverLastName: "Etternavn",
            eMail: "E-post",
            phoneNumber: "Telefonnummer",
            streetAddress: "Gateadresse",
            zipCode: "Postnummer",
            city: "Sted",
            country: "Land",
            automatic: "Automatgir",
            manual: "Manuellgir",
            drivingLengthKm: "kjørelengde",
            unlimitedKm: "Ubegrenset",
            needMoreKm: "Trenger mer km?",
            rentalTermConfirmFirst: "Jeg har lest og aksepterte ",
            rentalTermConfirmSecond: "leievilkårene.",
            commentOrInformation: "Kommentarer / øvrig informasjon",
            price: "Pris",
            insurance: "Valg av forsikringer",
            continue: "Fortsett",
            carInformation: "Se gjennom",

            // Generic
            error: 'Feil',
            confirmation: 'Bekreftelse',
            select: "Velg",
            pleaseWaitAMoment: "Vennligst vent et øyeblikk ...",
            back: "Tilbake"
        }
    },
};